import { EChatWindowActionTypes } from '../../actions/chatWindow';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function chatWindowReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EChatWindowActionTypes.OpenChat:
      return {
        ...state,
        chatWindow: {
          ...state.chatWindow,
          currentOpenedChatId: action.payload,
        },
      };

    case EChatWindowActionTypes.CloseChat:
      return {
        ...state,
        chatWindow: {
          ...state.chatWindow,
          currentOpenedChatId: '',
          activeReplyMessage: null,
        },
      };

    case EChatWindowActionTypes.ResetChat:
      return {
        ...state,
        chatWindow: {
          isChatOperationPending: false,
          isBubbleInputFocused: false,
          currentOpenedChatId: null,
          countClosedChats: 0,
          activeReplyMessage: null,
        },
      };
    case EChatWindowActionTypes.IncreaseCountClosedChats:
      return {
        ...state,
        chatWindow: {
          ...state.chatWindow,
          countClosedChats: state.chatWindow.countClosedChats + 1,
        },
      };

    case EChatWindowActionTypes.SetActiveReplyMessage: {
      return {
        ...state,
        chatWindow: {
          ...state.chatWindow,
          activeReplyMessage: action.payload,
        },
      };
    }

    case EChatWindowActionTypes.ClearActiveReplyMessage: {
      return {
        ...state,
        chatWindow: {
          ...state.chatWindow,
          activeReplyMessage: null,
        },
      };
    }

    default:
      return state;
  }
}
